import { render, staticRenderFns } from "./SoftResultDisplay.vue?vue&type=template&id=603c09a3&"
import script from "./SoftResultDisplay.vue?vue&type=script&lang=js&"
export * from "./SoftResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SoftResultDisplay.vue?vue&type=style&index=0&id=603c09a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports